// Used to get just the base path from NextJS' router.asPath (no query string or hash/anchor information)
export default function getBasePath(asPath) {
  // Remove the query string (everything after '?')
  let path = asPath.split("?")[0]
  // Remove the hash (everything after '#')
  path = path.split("#")[0]
  return path
}
